export const LANDING = '/';
export const HOME = '/home';
export const  CREW = '/crew';